export default __webpack_public_path__ + "static/media/closet5-before3-1024w.a9d82eb3.avif";